export enum CompanyBillingFlags {
  /**
   * main form action flag
   */
  ACTION,
  /**
   * show/hide mobal
   */
  SHOW_SUCCESS_MODAL,
  /**
   * action loading button modal
   */
  ACTION_SUCCESS_MODAL,
  /**
   * loading success modal
   */
  LOADING_SUCCESS_MODAL,
}
